import api from '@/api';
import { API_BASE_URL } from '..';
import { PageResult } from '@/core/request/PageResult';
import {
  WorkOrderKit,
  WorkOrderKitDetailRequest,
  WorkOrderKitListRequest,
} from './Kits.types';

const CONTROLLER_URL = `${API_BASE_URL}/Kits`;

export default {
  async list(params?: WorkOrderKitListRequest) {
    const result = (await api.get(CONTROLLER_URL, params)) as unknown;

    return result as PageResult<WorkOrderKit>;
  },

  async detail(params?: WorkOrderKitDetailRequest) {
    const result = (await api.get(`${CONTROLLER_URL}/${params?.kitId}`, {
      companyId: params?.companyId,
    })) as unknown;

    return result as WorkOrderKit;
  },
};
